
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[...service]",
      function () {
        return require("private-next-pages/services/[...service].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[...service]"])
      });
    }
  